export const countryCoordinates = [
  { name: 'Afghanistan', coordinates: [67.709953, 33.93911], code: 'AF' },
  { name: 'Albania', coordinates: [20.168331, 41.153332], code: 'AL' },
  { name: 'Algeria', coordinates: [1.659626, 28.033886], code: 'DZ' },
  { name: 'Andorra', coordinates: [1.52109, 42.546245], code: 'AD' },
  { name: 'Angola', coordinates: [17.873887, -11.202692], code: 'AO' },
  { name: 'Antigua and Barbuda', coordinates: [-61.796428, 17.060816], code: 'AG' },
  { name: 'Argentina', coordinates: [-63.616672, -38.416097], code: 'AR' },
  { name: 'Armenia', coordinates: [45.038189, 40.069099], code: 'AM' },
  { name: 'Australia', coordinates: [133.775136, -25.274398], code: 'AU' },
  { name: 'Austria', coordinates: [14.550072, 47.516231], code: 'AT' },
  { name: 'Azerbaijan', coordinates: [47.576927, 40.143105], code: 'AZ' },
  { name: 'Bahamas', coordinates: [-77.396279, 25.03428], code: 'BS' },
  { name: 'Bahrain', coordinates: [50.5577, 26.0667], code: 'BH' },
  { name: 'Bangladesh', coordinates: [90.356331, 23.684994], code: 'BD' },
  { name: 'Barbados', coordinates: [-59.543198, 13.193887], code: 'BB' },
  { name: 'Belarus', coordinates: [27.953389, 53.709807], code: 'BY' },
  { name: 'Belgium', coordinates: [4.469936, 50.503887], code: 'BE' },
  { name: 'Belize', coordinates: [-88.49765, 17.189877], code: 'BZ' },
  { name: 'Benin', coordinates: [2.315834, 9.30769], code: 'BJ' },
  { name: 'Bhutan', coordinates: [90.433601, 27.514162], code: 'BT' },
  { name: 'Bolivia', coordinates: [-63.588653, -16.290154], code: 'BO' },
  { name: 'Bosnia and Herzegovina', coordinates: [17.679076, 43.915886], code: 'BA' },
  { name: 'Botswana', coordinates: [24.684866, -22.328474], code: 'BW' },
  { name: 'Brazil', coordinates: [-51.92528, -14.235004], code: 'BR' },
  { name: 'Brunei', coordinates: [114.727669, 4.535277], code: 'BN' },
  { name: 'Bulgaria', coordinates: [25.48583, 42.733883], code: 'BG' },
  { name: 'Burkina Faso', coordinates: [-1.561593, 12.238333], code: 'BF' },
  { name: 'Burundi', coordinates: [29.918886, -3.373056], code: 'BI' },
  { name: 'Cambodia', coordinates: [104.990963, 12.565679], code: 'KH' },
  { name: 'Cameroon', coordinates: [12.354722, 7.369722], code: 'CM' },
  { name: 'Canada', coordinates: [-106.346771, 56.130366], code: 'CA' },
  { name: 'Cape Verde', coordinates: [-23.0418, 15.120142], code: 'CV' },
  { name: 'Central African Republic', coordinates: [20.939444, 6.611111], code: 'CF' },
  { name: 'Chad', coordinates: [18.732207, 15.454166], code: 'TD' },
  { name: 'Chile', coordinates: [-71.542969, -35.675147], code: 'CL' },
  { name: 'China', coordinates: [104.195397, 35.86166], code: 'CN' },
  { name: 'Colombia', coordinates: [-74.297333, 4.570868], code: 'CO' },
  { name: 'Comoros', coordinates: [43.3333, -11.6455], code: 'KM' },
  { name: 'Congo (Democratic Republic)', coordinates: [21.758664, -4.038333], code: 'CD' },
  { name: 'Congo (Republic)', coordinates: [15.827659, -0.228021], code: 'CG' },
  { name: 'Costa Rica', coordinates: [-83.753428, 9.748917], code: 'CR' },
  { name: 'Croatia', coordinates: [15.2, 45.1], code: 'HR' },
  { name: 'Cuba', coordinates: [-77.781167, 21.521757], code: 'CU' },
  { name: 'Cyprus', coordinates: [33.429859, 35.126413], code: 'CY' },
  { name: 'Czech Republic', coordinates: [15.472962, 49.817492], code: 'CZ' },
  { name: 'Denmark', coordinates: [9.501785, 56.26392], code: 'DK' },
  { name: 'Djibouti', coordinates: [42.590275, 11.825138], code: 'DJ' },
  { name: 'Dominica', coordinates: [-61.370976, 15.414999], code: 'DM' },
  { name: 'Dominican Republic', coordinates: [-70.162651, 18.735693], code: 'DO' },
  { name: 'Ecuador', coordinates: [-78.183406, -1.831239], code: 'EC' },
  { name: 'Egypt', coordinates: [30.802498, 26.820553], code: 'EG' },
  { name: 'El Salvador', coordinates: [-88.89653, 13.794185], code: 'SV' },
  { name: 'Equatorial Guinea', coordinates: [10.267895, 1.650801], code: 'GQ' },
  { name: 'Eritrea', coordinates: [39.782334, 15.179384], code: 'ER' },
  { name: 'Estonia', coordinates: [25.013607, 58.595272], code: 'EE' },
  { name: 'Eswatini', coordinates: [31.465866, -26.522503], code: 'SZ' },
  { name: 'Ethiopia', coordinates: [39.955277, 9.145], code: 'ET' },
  { name: 'Fiji', coordinates: [178.065032, -17.713371], code: 'FJ' },
  { name: 'Finland', coordinates: [25.748151, 61.92411], code: 'FI' },
  { name: 'France', coordinates: [2.213749, 46.227638], code: 'FR' },
  { name: 'Gabon', coordinates: [11.609444, -0.803689], code: 'GA' },
  { name: 'Gambia', coordinates: [-15.310139, 13.443182], code: 'GM' },
  { name: 'Georgia', coordinates: [43.356891, 42.315407], code: 'GE' },
  { name: 'Germany', coordinates: [10.451526, 51.165691], code: 'DE' },
  { name: 'Ghana', coordinates: [-1.023194, 7.946527], code: 'GH' },
  { name: 'Greece', coordinates: [21.824312, 39.074208], code: 'GR' },
  { name: 'Grenada', coordinates: [-61.604171, 12.262776], code: 'GD' },
  { name: 'Guatemala', coordinates: [-90.230759, 15.783471], code: 'GT' },
  { name: 'Guinea', coordinates: [-9.696645, 9.945587], code: 'GN' },
  { name: 'Guinea-Bissau', coordinates: [-15.180413, 11.803749], code: 'GW' },
  { name: 'Guyana', coordinates: [-58.93018, 4.860416], code: 'GY' },
  { name: 'Haiti', coordinates: [-72.285215, 18.971187], code: 'HT' },
  { name: 'Honduras', coordinates: [-86.241905, 15.199999], code: 'HN' },
  { name: 'Hungary', coordinates: [19.503304, 47.162494], code: 'HU' },
  { name: 'Iceland', coordinates: [-19.020835, 64.963051], code: 'IS' },
  { name: 'India', coordinates: [78.96288, 20.593684], code: 'IN' },
  { name: 'Indonesia', coordinates: [113.921327, -0.789275], code: 'ID' },
  { name: 'Iran', coordinates: [53.688046, 32.427908], code: 'IR' },
  { name: 'Iraq', coordinates: [43.679291, 33.223191], code: 'IQ' },
  { name: 'Ireland', coordinates: [-8.24389, 53.41291], code: 'IE' },
  { name: 'Israel', coordinates: [34.851612, 31.046051], code: 'IL' },
  { name: 'Italy', coordinates: [12.56738, 41.87194], code: 'IT' },
  { name: 'Jamaica', coordinates: [-77.297508, 18.109581], code: 'JM' },
  { name: 'Japan', coordinates: [138.252924, 36.204824], code: 'JP' },
  { name: 'Jordan', coordinates: [36.238414, 30.585164], code: 'JO' },
  { name: 'Kazakhstan', coordinates: [66.923684, 48.019573], code: 'KZ' },
  { name: 'Kenya', coordinates: [37.906193, -1.292066], code: 'KE' },
  { name: 'Kiribati', coordinates: [173.020371, -3.370417], code: 'KI' },
  { name: 'Kuwait', coordinates: [47.481766, 29.31166], code: 'KW' },
  { name: 'Kyrgyzstan', coordinates: [74.766098, 41.20438], code: 'KG' },
  { name: 'Laos', coordinates: [102.495496, 19.85627], code: 'LA' },
  { name: 'Latvia', coordinates: [24.603189, 56.879635], code: 'LV' },
  { name: 'Lebanon', coordinates: [35.862285, 33.854721], code: 'LB' },
  { name: 'Lesotho', coordinates: [28.233608, -29.609988], code: 'LS' },
  { name: 'Liberia', coordinates: [-9.429499, 6.428055], code: 'LR' },
  { name: 'Libya', coordinates: [17.228331, 26.3351], code: 'LY' },
  { name: 'Liechtenstein', coordinates: [9.555373, 47.166], code: 'LI' },
  { name: 'Lithuania', coordinates: [23.881275, 55.169438], code: 'LT' },
  { name: 'Luxembourg', coordinates: [6.129583, 49.815273], code: 'LU' },
  { name: 'Madagascar', coordinates: [46.869107, -18.766947], code: 'MG' },
  { name: 'Malawi', coordinates: [34.301525, -13.254308], code: 'MW' },
  { name: 'Malaysia', coordinates: [101.975766, 4.210484], code: 'MY' },
  { name: 'Maldives', coordinates: [73.22068, 3.202778], code: 'MV' },
  { name: 'Mali', coordinates: [-3.996166, 17.570692], code: 'ML' },
  { name: 'Malta', coordinates: [14.375416, 35.937496], code: 'MT' },
  { name: 'Marshall Islands', coordinates: [171.184478, 7.131474], code: 'MH' },
  { name: 'Mauritania', coordinates: [-10.940835, 21.00789], code: 'MR' },
  { name: 'Mauritius', coordinates: [57.552152, -20.348404], code: 'MU' },
  { name: 'Mexico', coordinates: [-102.552784, 23.634501], code: 'MX' },
  { name: 'Micronesia', coordinates: [158.215073, 6.887379], code: 'FM' },
  { name: 'Moldova', coordinates: [28.369885, 47.411631], code: 'MD' },
  { name: 'Monaco', coordinates: [7.412841, 43.750298], code: 'MC' },
  { name: 'Mongolia', coordinates: [103.846656, 46.862496], code: 'MN' },
  { name: 'Montenegro', coordinates: [19.37439, 42.708678], code: 'ME' },
  { name: 'Morocco', coordinates: [-7.09262, 31.791702], code: 'MA' },
  { name: 'Mozambique', coordinates: [35.529562, -18.665695], code: 'MZ' },
  { name: 'Myanmar', coordinates: [95.956223, 21.913965], code: 'MM' },
  { name: 'Namibia', coordinates: [18.49041, -22.95764], code: 'NA' },
  { name: 'Nauru', coordinates: [166.931503, -0.522778], code: 'NR' },
  { name: 'Nepal', coordinates: [84.124008, 28.394857], code: 'NP' },
  { name: 'Netherlands', coordinates: [5.291266, 52.132633], code: 'NL' },
  { name: 'New Zealand', coordinates: [174.885971, -40.900557], code: 'NZ' },
  { name: 'Nicaragua', coordinates: [-85.207229, 12.865416], code: 'NI' },
  { name: 'Niger', coordinates: [8.081666, 17.607789], code: 'NG' },
  { name: 'Nigeria', coordinates: [8.675277, 9.081999], code: 'NG' },
  { name: 'North Korea', coordinates: [127.510093, 40.339852], code: 'KP' },
  { name: 'North Macedonia', coordinates: [21.745275, 41.608635], code: 'MK' },
  { name: 'Norway', coordinates: [8.468946, 60.472024], code: 'NO' },
  { name: 'Oman', coordinates: [55.923255, 21.512583], code: 'OM' },
  { name: 'Pakistan', coordinates: [69.345116, 30.375321], code: 'PK' },
  { name: 'Palau', coordinates: [134.58252, 7.51498], code: 'PW' },
  { name: 'Palestine', coordinates: [35.233154, 31.952162], code: 'PS' },
  { name: 'Panama', coordinates: [-80.782127, 8.537981], code: 'PA' },
  { name: 'Papua New Guinea', coordinates: [143.95555, -6.314993], code: 'PG' },
  { name: 'Paraguay', coordinates: [-58.443832, -23.442503], code: 'PY' },
  { name: 'Peru', coordinates: [-75.015152, -9.189967], code: 'PE' },
  { name: 'Philippines', coordinates: [121.774017, 12.879721], code: 'PH' },
  { name: 'Poland', coordinates: [19.145136, 51.919438], code: 'PL' },
  { name: 'Portugal', coordinates: [-8.224454, 39.399872], code: 'PT' },
  { name: 'Qatar', coordinates: [51.183884, 25.354826], code: 'QA' },
  { name: 'Romania', coordinates: [24.96676, 45.943161], code: 'RO' },
  { name: 'Russia', coordinates: [105.318756, 61.52401], code: 'RU' },
  { name: 'Rwanda', coordinates: [29.873888, -1.940278], code: 'RW' },
  { name: 'Saint Kitts and Nevis', coordinates: [-62.782998, 17.357822], code: 'KN' },
  { name: 'Saint Lucia', coordinates: [-60.978893, 13.909444], code: 'LC' },
  { name: 'Saint Vincent and the Grenadines', coordinates: [-61.287228, 12.984305], code: 'VC' },
  { name: 'Samoa', coordinates: [-172.104629, -13.759029], code: 'WS' },
  { name: 'San Marino', coordinates: [12.457777, 43.933594], code: 'SM' },
  { name: 'Sao Tome and Principe', coordinates: [6.613081, 0.18636], code: 'ST' },
  { name: 'Saudi Arabia', coordinates: [45.079162, 23.885942], code: 'SA' },
  { name: 'Senegal', coordinates: [-14.452362, 14.497401], code: 'SN' },
  { name: 'Serbia', coordinates: [21.005859, 44.016521], code: 'RS' },
  { name: 'Seychelles', coordinates: [55.491977, -4.679574], code: 'SC' },
  { name: 'Sierra Leone', coordinates: [-11.779889, 8.460555], code: 'SL' },
  { name: 'Singapore', coordinates: [103.819836, 1.352083], code: 'SG' },
  { name: 'Slovakia', coordinates: [19.699024, 48.669026], code: 'SK' },
  { name: 'Slovenia', coordinates: [14.995463, 46.151241], code: 'SI' },
  { name: 'Solomon Islands', coordinates: [160.156194, -9.64571], code: 'SB' },
  { name: 'Somalia', coordinates: [46.199616, 5.152149], code: 'SO' },
  { name: 'South Africa', coordinates: [22.937506, -30.559482], code: 'ZA' },
  { name: 'South Korea', coordinates: [127.766922, 35.907757], code: 'KR' },
  { name: 'South Sudan', coordinates: [31.306978, 7.869943], code: 'SS' },
  { name: 'Spain', coordinates: [-3.74922, 40.463667], code: 'ES' },
  { name: 'Sri Lanka', coordinates: [80.771797, 7.873054], code: 'LK' },
  { name: 'Sudan', coordinates: [30.217636, 12.862807], code: 'SD' },
  { name: 'Suriname', coordinates: [-56.027783, 3.919305], code: 'SR' },
  { name: 'Sweden', coordinates: [18.643501, 60.128161], code: 'SE' },
  { name: 'Switzerland', coordinates: [8.227512, 46.818188], code: 'CH' },
  { name: 'Syria', coordinates: [38.996815, 34.802075], code: 'SY' },
  { name: 'Tajikistan', coordinates: [71.276093, 38.861034], code: 'TJ' },
  { name: 'Tanzania', coordinates: [34.888822, -6.369028], code: 'TZ' },
  { name: 'Thailand', coordinates: [100.992541, 15.870032], code: 'TH' },
  { name: 'Timor-Leste', coordinates: [125.727539, -8.874217], code: 'TL' },
  { name: 'Togo', coordinates: [0.824782, 8.619543], code: 'TG' },
  { name: 'Tonga', coordinates: [-175.198242, -21.178986], code: 'TO' },
  { name: 'Trinidad and Tobago', coordinates: [-61.222503, 10.691803], code: 'TT' },
  { name: 'Tunisia', coordinates: [9.537499, 33.886917], code: 'TN' },
  { name: 'Turkey', coordinates: [35.243322, 38.963745], code: 'TR' },
  { name: 'Turkmenistan', coordinates: [59.556278, 38.969719], code: 'TM' },
  { name: 'Tuvalu', coordinates: [179.194206, -7.109535], code: 'TV' },
  { name: 'Uganda', coordinates: [32.290275, 1.373333], code: 'UG' },
  { name: 'Ukraine', coordinates: [31.16558, 48.379433], code: 'UA' },
  { name: 'United Arab Emirates', coordinates: [53.847818, 23.424076], code: 'AE' },
  { name: 'United Kingdom', coordinates: [-3.435973, 55.378051], code: 'GB' },
  { name: 'United States', coordinates: [-95.712891, 37.09024], code: 'US' },
  { name: 'Uruguay', coordinates: [-55.765835, -32.522779], code: 'UY' },
  { name: 'Uzbekistan', coordinates: [64.585262, 41.377491], code: 'UZ' },
  { name: 'Vanuatu', coordinates: [166.959158, -15.376706], code: 'VU' },
  { name: 'Vatican City', coordinates: [12.453389, 41.902916], code: 'VA' },
  { name: 'Venezuela', coordinates: [-66.58973, 6.42375], code: 'VE' },
  { name: 'Vietnam', coordinates: [108.277199, 14.058324], code: 'VN' },
  { name: 'Yemen', coordinates: [48.516388, 15.552727], code: 'YE' },
  { name: 'Zambia', coordinates: [27.849332, -13.133897], code: 'ZM' },
  { name: 'Zimbabwe', coordinates: [29.154857, -19.015438], code: 'ZW' },
];
